const LOCAL_RE = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
const LABEL_RE = /^[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/;
const TLD_RE = /^[A-Za-z]{2,63}$/;

// Mirrors backend routes_email_health.validate_email_format
export function validateEmailFormat(value) {
  const s = (value || '').trim();
  if (!s) return { valid: false, reason: 'Email address is empty' };
  if (s.length > 254) return { valid: false, reason: 'Email address is too long' };
  if ((s.match(/@/g) || []).length !== 1) return { valid: false, reason: 'Must contain exactly one @' };
  const [local, domain] = s.split('@');
  if (!local || local.length > 64) return { valid: false, reason: 'The part before @ is missing or too long' };
  if (!LOCAL_RE.test(local)) return { valid: false, reason: 'Invalid characters or misplaced dots before the @' };
  if (!domain || !domain.includes('.')) return { valid: false, reason: 'Domain must include a dot, e.g. example.com' };
  const labels = domain.split('.');
  if (labels.some((l) => !LABEL_RE.test(l))) return { valid: false, reason: 'Domain contains an invalid part' };
  if (!TLD_RE.test(labels[labels.length - 1])) return { valid: false, reason: 'Domain ending (e.g. .com, .au) looks wrong' };
  return { valid: true, reason: '' };
}

export const HEALTH_META = {
  ok: { label: 'Deliverable', color: '#1a7f37' },
  warn: { label: 'Unverified', color: '#8a5a00' },
  bad: { label: 'Problem', color: '#8a1f11' },
  none: { label: 'No email', color: 'var(--olive)' },
  unchecked: { label: 'Not checked', color: 'var(--olive)' },
};

export const healthStatus = (u) => (u?.email_health?.status) || (u?.email ? 'unchecked' : 'none');
